<template>
  <div id="login" class="page-bg valign-wrapper" :style="styles">

    <div class="container">
      <div class="row">

        <form ref="form" class="form-app col s12 m8 offset-m2 bg-black-opacity-hard" autocomplete="off" onsubmit="return false;">

          <a v-if="platform === 'browser'" class="close-form" href="#" v-on:click="close">
            <icon name="times-circle" :scale="4" style="color: #fff"></icon>
          </a>

          <div class="browser-default col s12">
            <label for="username">{{$t("LOGIN1.USERNAME")}}</label>
            <input id="username" class="focusable" type="text" v-model="username" required>
          </div>
          <div class="browser-default col s12">
            <label for="password">{{$t("LOGIN1.PASSWORD")}}</label>
            <input id="password" class="focusable" type="password" v-model="password" required>
          </div>
          <div class="col s12">
              <label style="float: right;">
                <p style="margin: 0;"><icon name="lock" scale="1"></icon> <a :href="urlPass" style="font-size: 1rem; color: #f8f9fa!important;">{{$t("WELCOME.REMEMBER")}}</a></p>
              </label>
          </div>
          <div class="input-field col s12">
            <div ref="error" class="error" style="text-align: center;">
              <span class="message">Error</span>
            </div>
          </div>
          <div class="center-align col s12">
            <button class="waves-effect waves-light btn-large focusable" v-on:click="login" v-on:keyup.enter="login" :disabled="waiting">
              <span v-if='!waiting'>Login</span>
              <icon v-else name="sync" spin  scale='1.8'></icon>
            </button>
            <a class="waves-effect waves-light btn-large" :href="url">{{$t("WELCOME.REGISTER")}}</a>
            <a v-if="$store.getters.getData.name === 'cepsa'" class="waves-effect waves-light btn-large" href="https://api-cepsa.interactvty.com/oauth2/login">Login corporativo</a>
          </div>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
// import SpatialNavigation from 'js-spatial-navigation'
// import Bus from '@/components/ControlBus'
import router from '@/router/index'
import { enviroment, platform } from '@/utils/constants'
require('materialize-css')
let auth = require('@/services/auth.js')

export default {
  name: 'LoginBrowser',
  data () {
    return {
      username: '',
      password: '',
      waiting: false,
      platform: platform
    }
  },
  created: function () {
    // si el usuario esta logeado cargamos contenidos
    if (this.$store.getters.user) {
      this.$router.push({name: 'welcome'})
    } else if (this.$store.getters.platform !== 'browser') {
      this.$router.replace({name: 'login-tv'})
    }
    // keys control
    // Bus.$on('key-back', this.keyBack)
  },
  // mounted: function () {
  //   this.SN = SpatialNavigation.add({ selector: '#login .focusable', restrict: 'self-only' })
  //   SpatialNavigation.makeFocusable(this.SN)
  //   SpatialNavigation.focus(this.SN)
  //   SpatialNavigation.resume()
  // },
  methods: {
    login () {
      if (this.$refs['form'].checkValidity() && !this.waiting) {
        // SpatialNavigation.pause()
        this.waiting = true
        this.$refs.error.classList.remove('visible')

        auth.getToken(this.$store.getters.getData.name + '_' + this.username, this.password).then(() => {
          auth.getUser().then(response => {
            this.$store.commit('setUser', response.data['results'][0])
            router.push({name: 'welcome'})
          })
        }).catch((error) => {
          // SpatialNavigation.resume()
          this.waiting = false
          this.$refs.error.classList.add('visible')
          // this.$refs.error.querySelector('.message').innerText = error.response.data[Object.keys(error.response.data)[0]]
          console.error(error)
          this.$refs.error.querySelector('.message').innerText = this.$i18n.t('LOGIN1.ERROR')
        })
      }
    },
    close () {
      this.$router.push({name: 'welcome'}) // si no hay suscripciones carga contents
    }
    // keyBack () {
    //   // this.$router.push({name: 'welcome'})
    //   this.$router.go(-1)
    // }
  },
  computed: {
    url: function () {
      let env = enviroment
      if (enviroment === 'api' || enviroment === 'api-pinko') { env = 'portal' }
      return 'https://' + env + '.interactvty.com/tv/' + this.$store.getters.getData.name + '/signup/'
      // return '#/browser-register'
    },
    urlPass: function () {
      let env = enviroment
      if (enviroment === 'api' || enviroment === 'api-pinko') { env = 'portal' }
      return 'https://' + env + '.interactvty.com/tv/' + this.$store.getters.getData.name + '/password-reset/'
      // return '#/browser-register'
    },
    styles: function () {
      if (this.$store.getters.getData.background_admin) {
        return {
          backgroundImage: 'url(' + this.$store.getters.getData.background_admin + ')'
        }
      }

      // default
      return {
        backgroundImage: `url(${require('@/assets/images/splash.jpg')})`
      }
    }
  }
  // beforeDestroy: function () {
  //   Bus.$off('key-back', this.keyBack)
  //   if (this.SN) SpatialNavigation.remove(this.SN)
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
#login
  // background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, .9)) , url('../../assets/images/splash.jpg')

  background-color: #000
  background-position: center center
  background-repeat: no-repeat
  background-size: cover

  &:before
    content: ''
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: 0
    z-index: -1

    background: rgba(0,0,0,.5);
    background-image: linear-gradient(0deg,rgba(0,0,0,0) 50%,rgba(0,0,0,.5) 100%),radial-gradient(50% 120%,rgba(0,0,0,0) 50%,rgba(0,0,0,.7) 100%)

  .container
    // margin-top: 5rem
    // padding: 2rem
    border-radius: 2px
    // max-width: 40vw

    form
      margin-top: 5rem
      padding: 2rem

      input, label
        color: #fff
        font-size: 1.4rem

.form-app
  position: relative

  .close-form
    position: absolute
    right: -1rem
    top: -1rem

.error
  visibility: hidden
  color: #ef5350

.visible
  visibility: visible

.btn-large
  margin: .2rem 0;
</style>



// WEBPACK FOOTER //
// src/pages/site/LoginBrowser.vue